import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import LargeText from '@/large-text'

import './styles.css'

const SectionCoreOffering = ({ gray, data }) => {
  return (
    <BusinessSection
      title="Our core offering"
      subtitle="The revolutionary Next Miss app"
      gray={gray}
      className="overflow-hidden"
    >
      <div className="flex flex-wrap mb5 mb6-m mb7-l">
        <div className="flex-grow-1 mw197 mr3 mr5-m mr6-l ml--100-sm">
          <Img sizes={data.coreOffering1.sizes} alt="" />
        </div>
        <div className="flex-grow-1 flex-basis-0">
          <LargeText align="left">
            This has never been more important in a world where the speed of digital transformation is disrupting entire industries and changing competitive landscapes. <br/><br/>
            We have developed a designated app for beauty pageant community. The new app’s purpose is to become the main digital media for beauty pageant fans around the world.
          </LargeText>
        </div>
      </div>

      <div className="flex">
        <div className="flex-grow-1 flex-basis-0">
          <LargeText align="right">
            In Next Miss app you can find a complete set of tools to run your beauty pageant digitally. On top of this, we consult, collaborate, challenge and create, to deliver great results for you. <br/><br/>
            Below, we introduce you our three core offerings of New Digital Tools, New Revenue Streams and Digital Experience and build on the premise that good is never good enough.
          </LargeText>
        </div>
        <div className="flex-grow-1 mw197 ml3 ml5-m ml6-l mr--100-sm">
          <Img sizes={data.coreOffering2.sizes} alt="" />
        </div>
      </div>
    </BusinessSection>
  )
}

export default SectionCoreOffering



// WEBPACK FOOTER //
// ./src/components/section-core-offering/section-core-offering.js